import React, { Component } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { action } from 'mobx'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'

import { SearchPanelContainer } from '@components/Search'
import { Dropdown } from '@components/Autocomplete'
import CollapsibleFilterGroup from '@components/CollapsibleFilterGroup'
import Spinner from '@components/spinner'
import MyProjectItem from './MyProjectItem'
import ProjectItemStats from './ProjectItemStats'

const openIn = [
  {
    id: '',
    label: 'Details'
  },
  {
    id: '/experts-pipeline',
    label: 'Experts pipeline'
  },
  {
    id: '/client-view',
    label: 'Client view'
  },
  {
    id: '/outcome',
    label: 'Outcome'
  },
  {
    id: '/invoice',
    label: 'Invoice'
  }
]

// a little function to help us with reordering the result

const grid = 0

const getItemStyle = (draggableStyle, isDragging) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: isDragging ? 'white' : 'inherit',
  border: 'none',
  'box-shadow': isDragging ? '2px 2px 25px -10px black' : '',

  // styles we need to apply on draggables
  ...draggableStyle
})

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? 'inherit' : 'inherit'
  // padding: grid,
  // width: 250
})

class MyProjectsPanel extends Component {
  static propTypes = {
    myProjectsStore: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.props.myProjectsStore.getAll()
  }

  checkIfActive = id => {
    const currentId = get(this.props.location.pathname.match(/\d+/), '0', null)
    return id.toString() === currentId
  }

  onLink = (e, id) => {
    e.preventDefault()
    this.props.history.push(
      '/my-projects/project/' + id + this.props.myProjectsStore.openIn
    )
  }

  onDragEnd = action(result => {
    // dropped outside the list
    if (!result.destination) {
      return
    }

    const [removed] = this.props.myProjectsStore.projects.splice(
      result.source.index,
      1
    )
    this.props.myProjectsStore.projects.splice(
      result.destination.index,
      0,
      removed
    )

    this.props.myProjectsStore.saveOrder()
  })

  render () {
    const { myProjectsStore } = this.props

    if (myProjectsStore.loading) return <Spinner />

    return (
      <SearchPanelContainer thin isMyProjectsPanel>
        <div className='my-projects-title'>
          <h2>Your projects ({this.props.myProjectsStore.projects.length})</h2>
          <ProjectItemStats project={this.props.myProjectsStore} />
        </div>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId='droppable'>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
              >
                {this.props.myProjectsStore.projects.map((p, index) => {
                  return (
                    <Draggable key={p.id} draggableId={p.id} index={index}>
                      {(provided, snapshot) => (
                        <div>
                          <div
                            ref={provided.innerRef}
                            style={getItemStyle(
                              provided.draggableProps.style,
                              snapshot.isDragging
                            )}
                            {...provided.dragHandleProps}
                          >
                            <Link
                              onClick={e => this.onLink(e, p.id)}
                              to={
                                '/project/' +
                                p.id +
                                this.props.myProjectsStore.openIn
                              }
                            >
                              <MyProjectItem
                                key={p.id}
                                project={p}
                                isSelected={this.checkIfActive(p.id)}
                              />
                            </Link>
                          </div>
                          {provided.placeholder}
                        </div>
                      )}
                    </Draggable>
                  )
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <div className='expert-search-item my-projects'>
          <CollapsibleFilterGroup title='Settings'>
            <div>
              <label>Open projects in</label>
              <Dropdown
                valueIsId
                selectedItem={this.props.myProjectsStore.openIn}
                itemToString={item => item && item.label}
                options={openIn}
                onChange={option =>
                  (this.props.myProjectsStore.openIn = option.id)
                }
              />
            </div>
          </CollapsibleFilterGroup>
        </div>
      </SearchPanelContainer>
    )
  }
}

export default withRouter(inject('myProjectsStore')(observer(MyProjectsPanel)))
